// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// Contextos
import { AuthProvider } from './context/AuthContext';
import { UserDataProvider } from './context/UserContext';
import { ShopProvider } from './context/ShopContext';
import { SocialProvider } from './context/SocialContext';
import { FinancialProvider } from './context/FinancialContext';
import { ImageProvider } from './context/ImageContext'; // 🟢 NOVO

import ErrorBoundary from './utils/ErrorBoundary';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <ImageProvider> {/* Imagens carregam cedo */}
        <UserDataProvider>
          <FinancialProvider>
            <SocialProvider>
              <ShopProvider>
                <ErrorBoundary>
                  <App />
                </ErrorBoundary>
              </ShopProvider>
            </SocialProvider>
          </FinancialProvider>
        </UserDataProvider>
      </ImageProvider>
    </AuthProvider>
  </React.StrictMode>
);